import React, {useEffect, useState} from "react";
import "./SendResponsive.scss";
import {useHistory, useParams} from "react-router";
import {useDispatchBasket, useBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import {clothing_product} from "../Clothing/Services_Clothing";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import {ArrowLeftOutlined, PlusCircleOutlined, MinusCircleOutlined} from '@ant-design/icons';
import {openNotificationWithIcon, Setup} from "../../Services";
import {useLocation} from "react-router-dom";
import {OnlineAddress} from "../../Components";


function BasketAddRemoveSub({item, reSort}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();

    //states
    const [loading, set_loading] = useState(false)


    useEffect(() => {

    }, [])


    const addToBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
            //local basket
            reSort(filter)
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
            reSort([...basket, {product: item, count: 1}])
        }
    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                    //local basket
                    reSort(basket.filter(product => product.product.uid !== item.uid))
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                    //local basket
                    reSort(filter)
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                //local basket
                reSort(basket.filter(product => product.product.uid !== item.uid))
            }
        }
    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product.product.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product => product.product.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }

    return (
        <div className="add-remove-section-sub">
            {checkCount() > 0 ? <>
                <i className="fa fa-minus" onClick={dec}></i>
                <span className="product-count-number">
                    {!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}
                </span>
            </> : null}
            {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:<span className="stock-over">ناموجود</span>}*/}
            <i className="fa fa-plus" onClick={inc}></i>
        </div>
    )
}


function BasketItem({history, b, resort}) {

    const mId = window.location.pathname.split("/")[2]

    return (
        <div className="basket-responsive-body-content-item">
            <div className="basket-responsive-body-content-item-info">
                <span className="basket-responsive-body-content-item-info-name">{b.product.name}</span>
                <span className="basket-responsive-body-content-item-info-desc">{b.product.desc}</span>
                <span className="basket-responsive-body-content-item-info-price"> {b.product.price} ریال</span>
                <br/>
                <BasketAddRemoveSub item={b.product} reSort={resort}/>
            </div>

            <div className="basket-responsive-body-content-item-images" onClick={e => {
                history.push(`/online-store-product/${mId}/${b.product.uid}`)
            }}>

                <img src={b.product.image} alt=""/>

                {/*add remove*/}
            </div>

        </div>
    )
}


function AttrSec({sec}) {
    return (
        <div className="description-section-item">
            {sec.map(m => {
                switch (m.type) {
                    case 'h2':
                        return (
                            <div className="description-section-item-title">
                                <span>{m.text}</span>
                            </div>
                        )
                        break;
                    case 'p':
                        return (
                            <div className="description-section-item-desc">
                                <p>{m.text}</p>
                            </div>
                        )
                        break;
                    case 'li':
                        return (
                            <div className="description-section-item-li">
                                <li>{m.text}</li>
                            </div>
                        )
                        break;
                }
            })}
        </div>
    )
}


function AddToBasket({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const {merchantId, productId} = useParams()
    const history = useHistory()

    //states
    const [loading, set_loading] = useState(false)


    const addToBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId, pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId, pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            openNotificationWithIcon('success', item, history, merchantId)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }

    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }
    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product.product.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product => product.product.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }


    return (
        <div className="add-remove-section-footer" style={{
            backgroundColor: '#05E5AF',
            margin: '20px 24px',
            borderRadius: 5,
            padding: '10px 13px',
            fontFamily: 'YekanRegular'
        }}>
            {checkCount() < 1 ? <span className="add-btn-text" style={{width: '100%'}} onClick={inc}>

                <div className="buy-btn" style={{margin: 0}}>
                {/*<div className="price">*/}
                    {/*    <span> { numberWithCommas(item.price)} ریال </span>*/}
                    {/*</div>*/}
                    <div className="title" style={{fontFamily: 'YekanBold'}}>
                    <span>افزودن به سبد خرید</span>
                </div>
            </div>
                </span> :
                <div className="active-footer-sec">
                    <div className="price-footer-sec">
                        <div className="percent-off-footer-cont">
                            {item && item.discount_percentage !== 0 ?
                                <span className="percent-off-footer"
                                      style={{width: 25, height: 25, fontSize: 12}}
                                >%{item.discount_percentage}</span> :
                                null
                            }

                            {/*<span style={{textDecoration:"line-through",fontSize:14}}>{numberWithCommas(checkCount()*item.price_original)}</span>*/}
                        </div>
                        <div style={{direction: "rtl"}}><span>{numberWithCommas(checkCount() * item.price)} ریال </span>
                        </div>
                    </div>
                    <div className="calc">
                        {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:null}*/}
                        {checkCount() > 0 ? <>
                            <i className="fa fa-minus" onClick={dec}></i>
                            <span style={{
                                direction: "rtl", padding: "0 16px",
                                color: 'black',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }} className="product-count-number">
                            {!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}
                        </span>
                        </> : null}
                        <i className="fa fa-plus" onClick={inc}></i>
                    </div>
                </div>
            }
        </div>
    )
}


function numberWithCommas(x) {
    if (x === 0) {
        return 0
    }
    if (x) {
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function SendResponsive({
                            set_desc,
                            desc,
                            price,
                            off,
                            total,
                            fname,
                            set_fname,
                            lname,
                            set_lname,
                            mobile,
                            set_mobile,
                            reSort,
                            basket,
                            times,
                            set_radio,
                            changeTime,
                            radio,
                            editUserFunc
                        }) {

    //hooks
    const {productId} = useParams()
    const history = useHistory()
    const location = useLocation();

    const [merchantId , set_merchantId] = useState(null);
    useEffect(()=>{
        let mId = window.location.pathname.split("/")[2]
        set_merchantId(mId)
    },[])

    useEffect(() => {
        console.log("Location : ", location);
    }, [])

    return (
        <>
            <HeaderDesktop mId={merchantId} active="shop"/>


            <div className="basket-responsive-wrapper">
                <div className="basket-responsive-container">

                    <div className="basket-responsive-invoice">

                        <div className="basket-responsive-invoice-sec">
                            <div className="basket-responsive-invoice-row">
                                <span>مجموع</span>
                                <span>{numberWithCommas(total)} ریال</span>
                            </div>

                            <div className="basket-responsive-invoice-row red-row">
                                <span>مجموع تخفیف اقلام</span>
                                <span>{numberWithCommas(off)} ریال</span>
                            </div>

                            <div className="basket-responsive-invoice-row">
                                <span>مبلغ قابل پرداخت</span>
                                <span>{numberWithCommas(price)} ریال</span>
                            </div>
                        </div>

                        <div className="basket-responsive-invoice-btn" onClick={e => {
                            editUserFunc()
                        }}>
                            <span>ادامه فرایند خرید</span>
                        </div>

                        {/*<div className="basket-responsive-invoice-club">*/}
                        {/*    <span>باشگاه مشتریان</span>*/}
                        {/*    <span>28 امتیاز</span>*/}
                        {/*</div>*/}

                    </div>

                    <div className="basket-responsive-body">
                        <div className="basket-responsive-body-banner">
                            <img
                                src="https://test-loyalty-minio.darkube.app/loyalty-media/page/section_item/desktop_images/%D8%A8%D9%87%D8%AF%D8%A7%D8%B4%D8%AA%DB%8C_1_qfNBfTW.png"
                                alt=""/>
                        </div>

                        <div className="basket-responsive-body-content">
                            {/*<br/>*/}
                            {/*<div className="basket-responsive-body-content-title">*/}
                            {/*    <span>سبد خرید شما</span>*/}
                            {/*</div>*/}
                            {/*<br/>*/}
                            <div className="basket-responsive-body-content-items-send">

                                {/*item*/}
                                <div className="basket-responsive-body-content-item-send">
                                    <div className="basket-responsive-body-content-item-title">
                                        <span>آدرس تحویل سفارش</span>
                                    </div>

                                    <div className="basket-responsive-body-content-address-row">
                                        {merchantId?<OnlineAddress merchantId={merchantId}/>:null}
                                    </div>

                                    {/*<div className="basket-responsive-body-content-address-row">*/}
                                    {/*    <div className="basket-responsive-body-content-address-row-info">*/}
                                    {/*        <span>ارومیه - پلاک 3</span>*/}
                                    {/*        <span>آذربایجان غربی - اورمیه</span>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="basket-responsive-body-content-address-row-input">*/}
                                    {/*        <input type="radio" name="address" id=""/>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<div className="basket-responsive-body-content-address-row">*/}
                                    {/*    <div className="basket-responsive-body-content-address-row-info">*/}
                                    {/*        <span>ستارخاان - شادی 40</span>*/}
                                    {/*        <span>تهران -تهران</span>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="basket-responsive-body-content-address-row-input">*/}
                                    {/*        <input type="radio" name="address" id=""/>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>

                                {/*item*/}
                                <div className="basket-responsive-body-content-item-send">
                                    <div className="basket-responsive-body-content-item-title">
                                        <span>توضیحات سفارش</span>
                                    </div>

                                    <div className="basket-responsive-body-content-description-row">
                                      <textarea
                                          value={desc}
                                          onChange={(e) => {
                                              set_desc(e.target.value)
                                          }} rows="4" cols="50">
                                      </textarea>
                                    </div>

                                </div>


                                {/*item*/}
                                <div className="basket-responsive-body-content-item-send">
                                    <div className="basket-responsive-body-content-item-title">
                                        <span>اطلاعات کاربر</span>
                                    </div>
                                    <div className="basket-responsive-body-content-user-row">
                                        <input
                                            onChange={e=>set_mobile(e.target.value)}
                                            value={mobile}
                                            type="text" name="" id="" placeholder={"موبایل"} disabled={true}/>
                                        <input
                                            onChange={e=>set_lname(e.target.value)}
                                            value={lname}
                                            type="text" name="" id="" placeholder={"نام خانوادگی"}/>
                                        <input
                                            onChange={e=>set_fname(e.target.value)}
                                            value={fname}
                                            type="text" name="" id="" placeholder={"نام"}/>
                                    </div>

                                </div>


                                {/*item*/}
                                <div className="basket-responsive-body-content-item-send">
                                    <div className="basket-responsive-body-content-item-title">
                                        <span>زمان ارسال</span>
                                    </div>

                                    <div className="basket-responsive-body-content-shipping-row">

                                        <div className="send-time-list">
                                            {times.map(item => {
                                                return (
                                                    <div className="send-time-item">
                                                        <span>{item.title}</span>
                                                        <input

                                                            onClick={() => {
                                                                set_radio(item.uid);
                                                                changeTime(item.uid)
                                                            }}
                                                            type="radio" name="send" id="" value={item.uid}
                                                            checked={radio === item.uid}/>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </div>

                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>

            <br/><br/>
            <FooterDesktop/>
        </>
    )

}

export default SendResponsive
